import { render, staticRenderFns } from "./SortAndFilterToolAlertsRS.vue?vue&type=template&id=392dc83c&scoped=true&"
import script from "./SortAndFilterToolAlertsRS.vue?vue&type=script&lang=js&"
export * from "./SortAndFilterToolAlertsRS.vue?vue&type=script&lang=js&"
import style0 from "./SortAndFilterToolAlertsRS.vue?vue&type=style&index=0&id=392dc83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392dc83c",
  null
  
)

export default component.exports